<template>
    <div>
        <div class="form-row">
            <div class="col" style="max-width: 75px;">
                <label>Key press</label>
            </div>
            <div class="col" style="max-width: 150px;">
                <label>ACTION</label>
            </div>
            <div class="col">
                <label>Current destinations</label>
            </div>
        </div>
        <div class="form-row" style="min-height: 40px;" v-if="initialIVR != null"
             v-for="(button,index) in initialIVR.buttons">
            <div class="col"
                 style="border-top: 1px solid lightgray;  border-right: 1px solid lightgray; max-width: 75px;">
                <h4 class="text-center mb--100 pt-2"> {{ index }}</h4>
            </div>
            <div class="col" style="border-top: 1px solid lightgray; max-width: 150px;">
                <base-button type="primary" class="mr-1" size="sm"
                             @click="$router.push({ path: `/callflow/${initialIVR.id}/${index}` })">
                    <span>Call Flow</span>
                </base-button>
                <el-tooltip content="Remove this button and its callflow"
                            effect="dark"
                            :open-delay="300"
                            placement="top">
                    <base-button icon @click="removeButton(index)" type="danger" size="sm"
                                 :loading="removing[index]" class="right">
                        <font-awesome-icon v-if="!removing[index]" :icon="['fal','trash']"></font-awesome-icon>
                    </base-button>
                </el-tooltip>
            </div>
            <div class="col" style="border-top: 1px solid lightgray;">
                <div v-for="(condition, index) in button">
                    <div v-if="condition.is_active">
                        <div v-for="(destination, index) in condition.destinations">
                            <div v-if="destination.type === 'default'">
                                <el-tag
                                    v-for="(device, index) in destination.devices"
                                    :key='device.id'
                                    color="#65A30D !important"
                                    :title="'Device: ' + device.name"
                                    :disable-transitions="false">
                                    <span v-if="condition.destinations.length > 1">{{ destination.order }} -</span>
                                    {{
                                        (device.extensionName != null && device.extensionName != '') ?
                                            device.extensionName : device.name
                                    }}
                                </el-tag>
                                <el-tag v-for="(number, index) in destination.numbers"
                                        color="#65A30D !important"
                                        :key='number'
                                        :title="'Number: ' + number"
                                        :disable-transitions="false">
                                    <span v-if="condition.destinations.length > 1">{{ destination.order }} -</span>
                                    {{ number }}
                                </el-tag>
                            </div>
                            <el-tag v-if="destination.type === 'queue'"
                                    color="#06B6D4  !important"
                                    :key='destination.queue'
                                    :title="'Queue: ' +  destination.queue.split('_')[1]"
                                    :disable-transitions="false">
                                <span v-if="condition.destinations.length > 1">{{ destination.order }} -</span>
                                {{ destination.queue.split('_')[1] }}
                            </el-tag>
                            <el-tag v-if="destination.type === 'voicemail'"
                                    color="#A8A29E  !important"
                                    :key='destination.voicemail'
                                    :title="'Voicemail: ' + destination.voicemail"
                                    :disable-transitions="false">
                                <span v-if="condition.destinations.length > 1">{{ destination.order }} -</span>
                                {{ destination.voicemail }}
                            </el-tag>
                            <el-tag v-if="destination.type === 'ivr'"
                                    color="#9333EA !important"
                                    :key='destination.ivr'
                                    :title="'IVR: ' + destination.ivr"
                                    :disable-transitions="false">
                                <span v-if="condition.destinations.length > 1">{{ destination.order }} -</span>
                                {{ destination.ivr }}
                            </el-tag>
                            <el-tag v-if="destination.type === 'ringgroup'"
                                    color="#06B6D4 !important"
                                    :key='destination.ringgroup'
                                    :title="'Ringgroup: ' + destination.ringgroup"
                                    :disable-transitions="false">
                                <span v-if="condition.destinations.length > 1">{{ destination.order }} -</span>
                                {{ destination.ringgroup }}
                            </el-tag>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="form-row">
            <div class="col text-center" style="border-top: 1px solid lightgray; ">
                <base-button v-if="Object.keys(initialIVR.buttons).includes('default') === false" type="info"
                             @click.native="addDefaultAction">
                    Set Default action
                </base-button>
                <base-button type="info" @click.native="showAddButtonModal = true">
                    <font-awesome-icon :icon="['fal','plus']"></font-awesome-icon>
                    Add New Keypress
                </base-button>
            </div>
        </div>

        <AddButtonModal :show.sync="showAddButtonModal" :ivr="initialIVR"
                        v-on:success="buttonAdded"></AddButtonModal>
    </div>

</template>

<script>
import AddButtonModal from "./AddButtonModal";
import swal from 'sweetalert2';
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
    name: "IVRKeys",
    components: {
        AddButtonModal,
        swal,
        VueTelInput,

    },
    props: {
        initialIVR: Object,
    },
    data() {
        return {
            showAddButtonModal: false,
            removing: [],
        }
    },
    methods: {
        removeButton(button) {
            let ivr = this.initialIVR.id;
            swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to restore this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    this.$set(this.removing, button, true);
                    this.$store.dispatch('ivr/removeButton', {ivr, button}).then(() => {
                        this.$notify({
                            verticalAlign: 'bottom',
                            horizontalAlign: 'right',
                            message: 'Your IVR button was removed!',
                            type: "success",
                            icon: "fal fa-trash",
                            title: "Removed!"
                        });

                        this.$emit('button-remove');
                    }).finally(() => {
                        this.$set(this.removing, button, false);
                    });
                }
            });
        },
        buttonAdded() {
            this.$emit('button-add');
        },
        addDefaultAction() {
            this.saving = true;
            let ivr = this.initialIVR.id;
            let button = 'default';
            this.$store.dispatch('ivr/addButton', {ivr, button}).then(() => {
                this.$notify({
                    verticalAlign: 'bottom',
                    horizontalAlign: 'right',
                    message: 'Default action was added, you can now configure it!',
                    type: "success",
                    icon: "fal fa-check",
                    title: "Added!"
                });
                this.$emit('success');
                this.$emit('button-add');
            }).catch((result) => {
                this.$notify({
                    position: "bottom-right",
                    message: 'Unable to add default action.',
                    type: "error",
                    icon: "fal fa-times",
                    title: "Error!"
                });
            })
        }
    },
    mounted() {
        this.showAddButtonModal = false;
    }
}
</script>

<style scoped>

</style>
